import { useTranslation } from "react-i18next";
import { MdOutlineArrowForward } from "react-icons/md";
import { Link } from "react-router-dom";
import thanksImage from "shared/assets/images/lmf/thanks.png";
import ys from "shared/assets/images/lmf/ys.png";
import Heart from "shared/components/SVG/LMF/Heart";
import User from "shared/components/SVG/LMF/User";
import { NAME_SPACES } from "shared/locales/constants";
import InfoBox from "../Components/InfoBox";
import Layout from "../Components/Layout";

const View = () => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.SUBSCRIPTION_DONE", { returnObjects: true });

  return (
    <Layout>
      <div className="lmfSubscription__done">
        <img src={thanksImage} alt="" />
        <h1 className="lmfSubscription__done--title done">
          {TRANSLATION.TITLE}
        </h1>
        <InfoBox
          variant="info"
          text={TRANSLATION.INFO}
          icon={<img src={ys} alt="" size={48} />}
        />

        <div className="message">
          <div className="left">
            <User size={40} />
            <span
              dangerouslySetInnerHTML={{ __html: TRANSLATION.SPACE }}
            ></span>
          </div>
        </div>

        <Link
          className="redirect"
          to="https://www.mutuelle-familiale.fr/"
          target="_blank"
        >
          <div className="left">
            <Heart size={40} />
            <span>{TRANSLATION.DISCOVER}</span>
          </div>
          <MdOutlineArrowForward size={24} color="#5A348C" />
        </Link>

        {/* <span
          className="header-description"
          dangerouslySetInnerHTML={{ __html: TRANSLATION.DESCRIPTION }}
        ></span> */}
      </div>
    </Layout>
  );
};

export default View;
